module.exports = __webpack_public_path__ + "static/media/layout-two-1.0b45fb8b.jpg";